<template>
  <div >
    <div class="path">
      <i class="el-icon-caret-right"></i>账号中心
      <i class="el-icon-arrow-right"></i> 企业概览
    </div>
    <el-main>
      <div class="main-wrapper">

        <div class="content-wrapper">
          <div>
            <el-form ref="form" label-width="210px">
              <div class="item-wrapper">
                <div class="item-title" style="font-size: 17px">
                  <span style="color: #3888d7; font-weight: bold">|</span>
                  <span style="margin-left: 2px; color: #333333">访问信息</span>
                </div>

                <div class="item-content">
                  <el-form-item label="注册时间">
                    <el-input :value="customer.createTime" type="text"
                              style="width: 420px"></el-input>
                  </el-form-item>

                  <el-form-item label="上次登录">
                    <el-input :value="customer.lastLoginTime" type="text"
                              style="width: 420px"></el-input>
                  </el-form-item>

                </div>
              </div>

              <div class="item-wrapper">

                <div class="item-title" style="font-size: 17px">
                  <span style="color: #3888d7; font-weight: bold">|</span>
                  <span style="margin-left: 2px; color: #333333">企业信息</span>
<!--                  <el-link :underline="false" @click="" type="primary">修改</el-link>-->
                </div>

                <div class="item-content">
                  <el-form-item label="公司名称">
                    <el-input type="text" :value="customer.name"
                              style="width: 420px">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="统一社会信用代码">
                    <el-input :value="customer.uscc" type="text" style="width: 420px"
                              maxlength="18" >
                    </el-input>
                  </el-form-item>


                  <el-form-item label="联系电话">
                    <el-input :value="customer.telephone" type="text"
                              style="width: 420px">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="联系邮箱">
                    <el-input :value="customer.email" type="text"
                              style="width: 420px">
                    </el-input>
                  </el-form-item>


                  <el-form-item label="公司地址">
                    <el-input :value="customer.address" type="text"
                              style="width: 420px">
                    </el-input>
                  </el-form-item>

                </div>
              </div>


              <div class="item-wrapper">
                <div class="item-title" style="font-size: 17px">
                  <span style="color: #3888d7; font-weight: bold">|</span>
                  <span style="margin-left: 2px; color: #333333">联系信息</span>
                  <el-link :underline="false" @click="openUpdateDialog()" type="primary">修改</el-link>
                </div>

                <div class="item-content">
                  <el-form-item label="联系人姓名">
                    <el-input :value="customer.managerName" type="text"
                              style="width: 420px"></el-input>
                  </el-form-item>

                  <el-form-item label="联系人手机号码">
                    <el-input :value="customer.managerPhone" type="text"
                              style="width: 420px"></el-input>
                  </el-form-item>

                </div>
              </div>

            </el-form>
          </div>
        </div>

        <el-dialog title="联系信息" :visible.sync="dialogFormVisible" width="640px">
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="联系人姓名" prop="managerName" :label-width="formLabelWidth">
              <el-input v-model="form.managerName" type="text"
                        placeholder="请填写管理人姓名"
                        style="width: 420px"></el-input>
            </el-form-item>
            <el-form-item label="联系人手机号码" prop="managerPhone" :label-width="formLabelWidth">
              <el-input v-model="form.managerPhone" type="text" oninput="value=value.replace(/[^\d]/g,'')"
                        maxlength="11"
                        placeholder="请填写11位手机号码"
                        style="width: 420px"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </div>
        </el-dialog>

      </div>
    </el-main>
  </div>
</template>

<script>
import {
  checkPhone,
  checkEmail
} from '@/common/utils.js'
import {
  reqCustomerInfo,
  reqUpdateManager
} from '@/api'

export default {
  name: 'CustomerInfo',

  data() {
    return {
      customer: {},
      dialogFormVisible: false,
      formData: '',
      form: {
        name: '', // 公司名称
        uscc: '', // 统一社会信用代码
        address: '', // 公司经营地址
        telephone: '', // 联系电话
        email: '', // 联系邮箱
        managerName: '', // 管理人姓名
        managerPhone: '' // 管理人手机号
      },
      formLabelWidth: '140px',
      rules: {
        name: [
          { required: true, message: '请填写公司名称', trigger: 'blur' },
          { min: 6, max: 32, message: '长度在 6 到 32 个字符', trigger: 'blur' }
        ],
        uscc: [
          { required: true, pattern: /^[\u4e00-\u9fa5_\x00-\xffa-zA-Z0-9.·-]+$/, message: '请填写15或18位统一社会信用代码', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请填写公司地址', trigger: 'blur'}
        ],
        telephone: [
          { required: true, message: '请填写联系电话', trigger: 'blur' }
        ],
        email: [
          { required: true, validator: checkEmail, trigger: 'blur' }
        ],
        managerName: [
          { required: true, pattern: /^[\u4e00-\u9fa5_\x00-\xffa-zA-Z0-9.·-]+$/, message: '请填写联系人姓名', trigger: 'blur' }
        ],
        managerPhone: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ]
      }
    }
  },

  async mounted () {
    const loading = this.$loading({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    const result = await reqCustomerInfo()
    if (result.code === 0) {
      this.customer = result.data
    }
    loading.close()
  },

  methods: {

    openUpdateDialog () {
      this.dialogFormVisible = true
    },

    submit () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '提交中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          const result = await reqUpdateManager(this.form.managerName, this.form.managerPhone)
          loading.close()
          await this.$alert(`${ result.message }`, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              if (result.code === 0) {
                this.dialogFormVisible = false
                this.customer.managerName = this.form.managerName
                this.customer.managerPhone = this.form.managerPhone
                this.$refs.form.resetFields()
              }
            }
          })

        } else {
          await this.$alert('输入信息不正确，请完善后再提交！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/CustomerInfo/CustomerInfo.vue